import { SimpleQuery, UrlQueryState } from "./types"
import { getUrlFromState } from "./getUrlFromState"
import { defaultSize } from "@/config"

export function updateUrl(state: UrlQueryState) {
  const url = getUrlFromState(state)
  const absolute = new URL(url, window.location.href).toString()
  if (window.location.href === absolute) {
    return
  }
  window.history.pushState(null, "", url)
}

export function updateUrlFromQuery({ page, size, query, filter, sort }: SimpleQuery) {
  updateUrl({
    query,
    filter,
    sort,
    page: page && page > 1 ? page : undefined,
    size: size !== defaultSize ? size : undefined
  })
}
